module.exports = __webpack_public_path__ + "static/media/socialConnection.034641c2.svg";